/** Task approvement status */
export enum TaskApprovementStatusEnum {
  /** Task approved */
  APPROVED = 'APPROVED', // Согласовано
  /** Task refused */
  REFUSED = 'REFUSED', // Не согласовано
  /** Pending approvement */
  PENDING = 'PENDING', // Ожидает согласования
}
